import React from 'react';
import IssuesList from '../IssuesList';

const ImageIssueList = (props) => {
    return <IssuesList listUrl="scan/image/report/list" type="image" />;
};

export default ImageIssueList;
